import Auth from './Auth.component'

import { actions, connect } from '../../_redux'

export interface IActions {
  infos: typeof actions.user.infos
}

export default connect(undefined, { infos: actions.user.infos })(Auth)
